import { TransitionSeries } from '@remotion/transitions';
import * as React from 'react';
import { FunctionComponent } from 'react';
import { createTransition } from '../remotion-helpers/create-transition';
import { useVideoConfig } from 'remotion';
import { TrackItem } from '../remotion-tracks';
import { renderContentByType } from '../remotion-tracks/remotion-tracks';

interface Props {
  tracks: TrackItem[];
  isRtl: boolean;
  absoluteFrame: number;
}

const RemotionTransition: FunctionComponent<Props> = ({
  tracks,
  isRtl,
  absoluteFrame,
}) => {
  const { fps, width, height } = useVideoConfig();

  const firstTrack = tracks[0];

  if (!firstTrack) {
    return null;
  }

  return (
    <TransitionSeries premountFor={20} from={firstTrack.from}>
      {tracks.map((track, index) => {
        const component = renderContentByType({
          trackItem: track,
          index,
          isRtl,
          absoluteFrame,
        });

        const transition = track.transition;

        if (!transition) {
          return (
            <TransitionSeries.Sequence
              key={index}
              durationInFrames={track.durationInFrames}
            >
              {component}
            </TransitionSeries.Sequence>
          );
        }

        const outTransitionResult =
          transition.outEffect &&
          createTransition({
            width,
            height,
            effect: transition.outEffect.effect,
          });

        return (
          <React.Fragment key={index}>
            <TransitionSeries.Sequence
              durationInFrames={
                track.durationInFrames + outTransitionResult.durationInFrames
              }
            >
              {component}
            </TransitionSeries.Sequence>
            {transition.outEffect && outTransitionResult && (
              <TransitionSeries.Transition
                timing={outTransitionResult.timing}
                //@ts-expect-error zubi
                presentation={outTransitionResult.presentation}
              />
            )}
          </React.Fragment>
        );
      })}
    </TransitionSeries>
  );
};

export default RemotionTransition;
